import { render, staticRenderFns } from "./OBSControlWidget.vue?vue&type=template&id=63932d73&scoped=true"
import script from "./OBSControlWidget.vue?vue&type=script&lang=js"
export * from "./OBSControlWidget.vue?vue&type=script&lang=js"
import style0 from "./OBSControlWidget.vue?vue&type=style&index=0&id=63932d73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63932d73",
  null
  
)

export default component.exports